import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import logo from "../assets/logo.png";
import "./Navbar.css";

function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const isLoginPage = location.pathname === "/login";

  return (
    <header className="swx-header" role="banner">
      {/* Left Logo */}
      <div className="swx-nav-left">
        <Link to="/" className="swx-logo" title="Soloway Sri Lanka Home">
          <img src={logo} alt="Soloway - Sri Lanka Travel Platform" className="logo-img" />
        </Link>
      </div>

      {/* Right user area */}
      <div className="swx-nav-right">
        {isLoginPage ? (
          <button className="swx-signin-btn" onClick={() => navigate("/register")}>
            Register <span>→</span>
          </button>
        ) : (
          <button className="swx-signin-btn" onClick={() => navigate("/login")}>
            Sign In <span>→</span>
          </button>
        )}
      </div>
    </header>
  );
}

export default Navbar;
